<template>
  <div class="body">
    <van-nav-bar title="售后详情" left-text left-arrow @click-left="onClickLeft" class="topNav"/>
    <div class="content" :style="state==1 ? 'margin-bottom:50px':''">
      <p class="OrderState">{{statetxt}}</p>
      <div class="supwrap ordercontent">
        <div class="orderImg">
          <img :src="goods.img | thumbnail(176,176)">
        </div>
        <div class="info">
          <p>{{goods.name}}</p>
          <p>x{{goods.num}}</p>
        </div>
      </div>
      <div class="supwrap OrderPrice">
        <p class="total">
          商品金额:
          <span>￥{{goods.price}}</span>
        </p>
        <p class="total">
          订单实付金额:
          <span>￥{{goods.pay}}</span>
        </p>
      </div>
      <div class="supwrap supType">
        <p>
          售后类型:
          <span>{{suptype}}</span>
        </p>
        <p>
          申请原因:
          <span>{{supreason}}</span>
        </p>
        <div v-if="img.length>0" class="supImg">
          <p class="supImgLeft">申请凭证:</p>
          <div class="supImgRight">
            <img :src="item" v-for="(item,index) in img" :key="index">
          </div>
        </div>
      </div>
      <div class="supwrap addressWrap" v-if="state>=1">
        <p class="supAddress">退款地址</p>
        <div class="addressCOntent">
          <p>
            收货人:
            <span>{{address.name}}</span>
          </p>
          <p>
            联系电话:
            <span>{{address.phone}}</span>
          </p>
          <p>
            详细地址:
            <span>{{address.detail}}</span>
          </p>
        </div>
        <div class="addressTips">
          <p>·未与卖家协商一致情况下，请勿寄到付或平邮</p>
          <p>·请填写真实有效物流信息</p>
        </div>
      </div>
      <div class="supwrap comWrap" v-if="state==1">
        <div class="comInfo">
          <label>物流公司:</label>
          <button class="com" @click="show()">{{selCom?expressname:'请选择物流公司'}}</button>
        </div>
        <div class="comInfo">
          <label>物流单号:</label>
          <input v-model="expresson">
        </div>
      </div>
      <button class="supsubmit" v-if="state==1" @click="SubmitSup()">确认发货</button>
    </div>
    <van-popup v-model="shows" position="bottom">
      <van-picker :columns="elist" @confirm="confirm" confirm-button-text="确定" :show-toolbar="true"/>
    </van-popup>
  </div>
</template>

<script>
import { SupDetail,SubmitSup } from "../../apis/https.js";
import { getLocalStorage } from "../../utils/storage.js";
import { stat } from "fs";
import { Picker, Popup } from "vant";
import Vue from "vue";
Vue.use(Picker).use(Popup);
export default {
  components: {},
  data() {
    return {
      id: "",
      statetxt: "",
      goods: {
        img: "",
        num: "",
        name: "",
        pay: "",
        price: ""
      },
      address: {
        name: "",
        phone: "",
        detail: ""
      },
      img:[],
      expressList: [],
      elist:[],
      suptype: "",
      supreason: "",
      state: "",
      selCom: false,
      shows: false,
      expressid:"",
      expresson:"",
      expressname:""
    };
  },
  created() {},
  activated() {
    this.id = this.$route.query.id;
    this.SupDetail(this.id, getLocalStorage("login_token"));
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    show(){
      this.shows=true;
    },
    confirm(value, index){
      this.selCom=true;
      this.expressid=this.expressList[index].express_id;
      this.expressname=this.expressList[index].express_name;
      this.shows=false;
    },
    SupDetail(id, token) {
      SupDetail(id, token).then(res => {
        let data = res.data.detail;
        this.statetxt = data.state_text;
        this.goods.img = data.order_goods.image.file_path;
        this.goods.num = data.order_goods.total_num;
        this.goods.name = data.order_goods.goods_name;
        this.goods.pay = data.order_goods.total_pay_price;
        this.goods.price = data.order_goods.total_price;
        this.suptype = data.type.text;
        this.supreason = data.apply_desc;
        this.expressList = res.data.expressList;
        if(data.image!=null){
          this.img=[];
          for(let i in data.image){
            this.img.push(data.image[i].file_path);
          }
        }
        for(let i in res.data.expressList){
          this.elist.push(res.data.expressList[i].express_name);
        }
        let state = 0;
        if (data.is_agree.value == 20) {
          state = -1; //已拒绝
        } else if (data.is_agree.value == 10 && data.is_user_send == 0) {
          state = 1; //已同意未发货
        } else if (
          data.is_agree.value == 10 &&
          data.is_user_send == 1 &&
          data.is_receipt == 0
        ) {
          state = 2; //已同意已发货未收货
        } else if (
          data.is_agree.value == 10 &&
          data.is_user_send == 1 &&
          data.is_receipt == 1
        ) {
          state = 3; //已同意已发货已收货 售后完成
        }
        this.state = state;
        if (state >= 1) {
          this.address.name = data.address.name;
          this.address.phone = data.address.phone;
          this.address.detail = data.address.detail;
        }
      });
    },
    SubmitSup() {
      SubmitSup(this.expressid,this.expresson,this.id,getLocalStorage("login_token")).then(res=>{
        this.$toast.success("已提交售后")
        this.$router.push('/support')
      })
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
.body {
  background: #f4f8fb;
  min-height: 100vh;
  overflow: hidden;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0px;
    i {
      color: #323233 !important;
    }
  }
  .content {
    margin-top: 46px;
    .supwrap {
      padding: 8px 15px;
      overflow: hidden;
      background: @white;
      margin-bottom: 10px;
    }
    .OrderState {
      height: 80px;
      font-size: 16px;
      line-height: 80px;
      padding: 0px 20px;
      background: url("../../assets/frame-img/refund-bg.jpg");
      color: @white;
    }
    .ordercontent {
      .orderImg {
        width: 80px;
        height: 80px;
        float: left;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .info {
        float: right;
        width: calc(100% - 80px);
        padding: 0px 10px;
        p:first-child {
          height: 40px;
          line-height: 40px;
          font-size: 15px;
          color: @darkP;
        }
        p:last-child {
          font-size: 14px;
          color: @lightP;
          text-align: right;
        }
      }
    }
    .OrderPrice {
      overflow: hidden;
      .total {
        text-align: right;
        font-size: 14px;
        span {
          color: @text;
        }
      }
    }
    .supType {
      background: @white;
      padding: 10px;
      p {
        font-size: 14px;
        color: @darkP;
        padding: 5px 0px;
      }
      .supImg{
        display: flex;
        .supImgLeft{  
          width: 70px;
        }
        .supImgRight{
          width: calc(100% - 70px);
          img{
            width: 80px;
            height: 80px;
            margin-right: 10px;
          }
        }
      }
    }
    .addressWrap {
      .supAddress {
        font-size: 16px;
        color: @text;
        padding: 10px 0px;
      }
      .addressCOntent {
        padding: 8px 0px;
        margin-bottom: 5px;
        border-bottom: 1px solid @veryLightLine;
        p {
          color: @darkP;
          font-size: 14px;
        }
      }
      .addressTips {
        padding: 10px 0px;
        p {
          color: @lightP;
          font-size: 13px;
        }
      }
    }
    .comWrap {
      .comInfo {
        display: flex;
        margin-bottom: 5px;
        .com {
          border: 0px;
          width: calc(100% - 80px);
          text-align: left;
          background: transparent;
          color: @darkP;
          border-bottom: 1px solid @lightP;
          font-size: 14px;
        }
        label {
          width: 80px;
          font-size: 14px;
          color: @darkP;
          line-height: 40px;
        }
        input {
          height: 40px;
          width: calc(100% - 80px);
          border-radius: 0px;
          border: 0px;
          border-bottom: 1px solid @lightP;
          font-size: 14px;
        }
      }
    }
    .supsubmit {
      width: 100%;
      height: 50px;
      position: fixed;
      bottom: 0px;
      background: @btn;
      color: @white;
      border: 0px;
      font-size: 14px;
    }
  }
}
</style>